import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import cookie from "react-cookies";
import toast from "../../components/common/Toast";
import { MessageOutlined } from "../../components/common/Icons";
import constants from "../../Constants";

const baseURL = constants.baseURL;

const ChatApp = () => {
  const [visible, setVisible] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const chatDrawerRef = useRef(null);

  const urlParams = new URLSearchParams(window.location.search);
  const quoteid = urlParams.get("quoteid") || localStorage.getItem("quoteid");
  const orderid = urlParams.get("orderid") || localStorage.getItem("orderid");
  const isdriver = urlParams.get("isdriver");

  const scrollToBottom = () => {
    const chatMessages = document.getElementById("chat-messages");
    if (chatMessages) {
      chatMessages.scrollTop = chatMessages?.scrollHeight;
    }
  };

  // Track tab visibility
  useEffect(() => {
    try {
      if (cookie.load("quotetoken") && !isdriver) {
        const enableAudio = () => {
          const notification1 = new Audio("/notification.mp3");
          notification1.play().catch((e) => {
            console.log("Audio error xx", e);
          }); // Ignore errors
          document.removeEventListener("click", enableAudio); // Remove listener after first interaction
        };
        document.addEventListener("click", enableAudio, { once: true });
      }
    } catch (error) {
      console.error("Audio error", error);
    }
  }, [isdriver]);
  const fetchMessages = useCallback(async () => {
    try {
      if ((!quoteid && !orderid) || (!cookie.load("quotetoken") || isdriver))
        return;
      setLoading(true);
      const response = await axios.get(
        baseURL +
          (quoteid
            ? "/customer-quote-comments?quoteid="
            : "/customer-order-comments?orderid=") +
          (quoteid || orderid),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: cookie.load("quotetoken"),
          },
        }
      );

      setMessages(response.data);
      if (
        response.data.length > 0 &&
        response.data.length > localStorage.getItem("local-notifications")
      ) {
        const notification1 = new Audio("/notification1.mp3");
        notification1.play().catch((e) => {
          console.log("Audio error 1", e);
        }); // Ignore errors
        const notification2 = new Audio("/notification1.mp3");
        notification2.play().catch((e) => {
          console.log("Audio error 2", e);
        }); // Ignore errors
        setTimeout(() => {
          notification1.play().catch((e) => {
            console.log("Audio error 1", e);
          }); //
        }, 5000);
        localStorage.setItem("local-notifications", response.data.length);
        scrollToBottom();
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to load messages");
    } finally {
      setLoading(false);
    }
  }, [quoteid, orderid, isdriver]);

  // Fetch messages every 15 seconds only if tab is active and chat is open
  useEffect(() => {
    let interval;
    fetchMessages();
    interval = setInterval(fetchMessages, 15000);
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [fetchMessages]);

  const handleSendMessage = async () => {
    if (!inputValue.trim()) return;
    setSending(true);
    scrollToBottom();
    try {
      await axios.post(
        baseURL +
          (quoteid
            ? "/customer-quote-comments"
            : "/customer-order-comments/send-message"),
        {
          message: inputValue,
          quoteid,
          orderid,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: cookie.load("quotetoken"),
          },
        }
      );
      setInputValue("");
      fetchMessages();
    } catch (error) {
      console.error(error);
      toast.error("Failed to send message");
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      {!visible &&
        cookie.load("quotetoken") &&
        !isdriver &&
        new Date().getHours() >= 8 && (
          <>
            <div
              style={{
                position: "fixed",
                bottom: 70,
                right: 24,
                zIndex: 1000000,
                background: "#4f6367",
                boxShadow: "0 2px 80px rgba(0, 0, 0, 1)",
                color: "white",
                padding: "4px 8px",
                borderRadius: 4,
                cursor: "pointer",
                textAlign: "center",
                fontSize: 12,
              }}
            >
              Quick question?
            </div>
            <button
              style={{
                position: "fixed",
                bottom: 24,
                right: 24,
                zIndex: 1000000,
                background: "orange",
                boxShadow: "0 2px 80px rgba(0, 0, 0, 1)",
                border: "none",
                borderRadius: "50%",
                width: 48,
                height: 48,
                cursor: "pointer",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 22,
              }}
              onClick={() => setVisible(true)}
            >
              <MessageOutlined />
            </button>
          </>
        )}

      {visible && (
      <div
        ref={chatDrawerRef}
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          zIndex: 1000001,
          background: "white",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", padding: "12px 16px", borderBottom: "1px solid #f0f0f0" }}>
          <MessageOutlined />
          <div style={{ marginLeft: 8, fontWeight: 600 }}>Chat with Admin</div>
          <a
            href={
              localStorage.getItem("quoteid")
                ? "/quote?quoteid=" + localStorage.getItem("quoteid")
                : localStorage.getItem("orderid")
                ? "/track-order?paynow=yes&orderid=" +
                  localStorage.getItem("orderid")
                : ""
            }
            style={{ marginLeft: "auto" }}
          >
            {localStorage.getItem("quoteid")
              ? " View Quote"
              : localStorage.getItem("orderid")
              ? "View Order"
              : ""}
          </a>
          <button onClick={() => setVisible(false)} style={{ marginLeft: 12, background: "none", border: "none", fontSize: 20, cursor: "pointer" }}>&times;</button>
        </div>
        <div
          style={{
            flex: 0.9,
            overflowY: "auto",
            padding: 16,
            background: "#4f6367",
            color: "white",
            borderRadius: "16px",
          }}
          id="chat-messages"
        >
          {messages.length === 0 && <p>No messages yet</p>}
          {messages.map((item) => {
            const isCurrentUser = item.actorid && item.actorid.includes("@");
            const d = new Date(item.dateadded);
            const dateStr = d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
            const timeStr = d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });
            return (
              <div
                key={item.orderconversationid}
                className={`chat-message ${isCurrentUser ? "user" : "other"}`}
              >
                <div className="bubble-owner">
                  {item.adminfirstname ||
                    item.driverfirstname ||
                    item.customerfirstname ||
                    "you"}
                  <div className="bubble-time">
                    {dateStr + " " + timeStr}
                  </div>
                </div>
                <div className="bubble">{item.message}</div>
              </div>
            );
          })}
          {loading && (
            <p
              style={{
                textAlign: "center",
                color: "grey",
                padding: 16,
                fontSize: 12,
              }}
            >
              contacting admin...
            </p>
          )}
        </div>

        <div style={{ padding: 16, borderTop: "1px solid #f0f0f0", display: "flex", gap: 8 }}>
          <input
            type="text"
            placeholder="Type your message..."
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
            disabled={sending || !cookie.load("quotetoken")}
            style={{ flex: 1, padding: "8px 12px", border: "1px solid #d9d9d9", borderRadius: 4, fontSize: 14 }}
          />
          <button
            onClick={handleSendMessage}
            disabled={sending || !cookie.load("quotetoken")}
            style={{ padding: "8px 16px", background: "#1890ff", color: "white", border: "none", borderRadius: 4, cursor: "pointer", fontSize: 14 }}
          >
            Send
          </button>
        </div>
      </div>
      )}
    </>
  );
};

export default ChatApp;
